/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-group-1 ul');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
       var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('#modalAddToCartError .error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        beforeSend: function() {
            if(form_id == "nj_qv_add_item_qv") {
                jQuery('#' + form_id).find(".nj_qv_addtocartqv button").text('please wait..');
            }
        },
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            }
            else {
                if(form_id != "nj_qv_add_item_qv") {
                    Shopify.cartPopapForm(line_item.title,line_item.image);
                } else {
                    jQuery('#' + form_id).find(".nj_qv_addtocartqv button").text('success..');
                    setTimeout(function() {
                        jQuery('#' + form_id).find(".nj_qv_addtocartqv button").text('add to cart');
                    }, 3000);
                }
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            if(form_id != "nj_qv_add_item_qv") {
                Shopify.onError(XMLHttpRequest, textStatus);
            } else {
                jQuery('#' + form_id).find(".nj_qv_addtocartqv button").text('already added..');
                setTimeout(function() {
                    jQuery('#' + form_id).find(".nj_qv_addtocartqv button").text('add to cart');
                }, 3000);
            }
            Shopify.onItemAdded(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};


/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(titlenihuh,imagess) {
    jQuery('#njohn_addtocart_name .njohn_addtocart_cell').html(titlenihuh);  
  	imagess = imagess.replace(/\.jpg\?v=/gi, '_small\.jpg\?v=');
    jQuery('#njohn_addtocart_img').html('<img src="'+imagess+'">');  
    jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(title,imagess) {
    jQuery('#njohn_addtocart_name .njohn_addtocart_cell').html(title); 
  	imagess = imagess.replace(/\.jpg\?v=/gi, '_small\.jpg\?v='); 
    jQuery('#njohn_addtocart_img').html('<img src="'+imagess+'">');  
    jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {

          if (value.length) {
            jQuery(".header-cart .dropdown-toggle").css({"cursor": "pointer"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="cart__item"><div class="cart__item__image pull-left"><a href="' + item.url + '"><img src="' + item.image + '" alt=""/></a> </div><div class="cart__item__control"><div class="cart__item__delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" class="icon icon-delete"><span>'+jQuery(".cart_messages .delete").text()+'</span></a></div><div class="cart__item__edit"><a href="' + item.url + '" class="icon icon-edit"><span>'+jQuery(".cart_messages .edit").text()+'</span></a></div></div><div class="cart__item__info"><div class="cart__item__info__title"><h2><a href="' + item.url + '">' + item.title + '</a></h2></div><div class="cart__item__info__price"><span class="info-label">'+jQuery(".cart_messages .price").text()+'</span><span>' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="cart__item__info__price" style="right: 35%;"><span class="info-label">'+jQuery(".cart_messages .qty").text()+'</span><span>' + item.quantity + '</span></div></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".header-cart .dropdown-toggle").css({"cursor": "default"});
          }
        }
      });
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
